
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/makers/[maker]",
      function () {
        return require("private-next-pages/shop/makers/[maker].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/makers/[maker]"])
      });
    }
  